<template>
  <div class="selfcheck-workspace">
    <div class="selfcheck-header">
      <h2 class="selfcheck-title">{{ currentTool.title }}</h2>
      <p class="selfcheck-subtitle">{{ currentTool.subtitle }}</p>
    </div>

    <!-- 数据表区域 -->
    <div class="selfcheck-table-section">
      <div class="table-header">
        <h3 class="table-title">学术自查数据表</h3>
        <span class="table-formats">CSV / TSV / XLSX</span>
      </div>
      <div class="table-container">
        <table class="selfcheck-table">
          <thead>
            <tr>
              <th>record_id</th>
              <th>group</th>
              <th>metric</th>
              <th>value</th>
              <th>unit</th>
              <th>timepoint</th>
              <th>source_table</th>
              <th>note</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>S001</td><td>Treatment</td><td>Axial length</td>
              <td>24.12</td><td>mm</td><td>baseline</td>
              <td>Table 1</td><td>原始测量</td>
            </tr>
            <tr>
              <td>S002</td><td>Treatment</td><td>Axial length</td>
              <td>24.28</td><td>mm</td><td>baseline</td>
              <td>Table 1</td><td>原始测量</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="template-downloads">
        <button class="download-btn" @click="$emit('download-template', 'xlsx')">
          <span class="download-icon">📊</span><span>下载 Excel 模板</span>
        </button>
        <button class="download-btn" @click="$emit('download-template', 'csv')">
          <span class="download-icon">📄</span><span>下载 CSV 模板</span>
        </button>
        <span class="upload-hint">上传 CSV、TSV 或 XLSX 数据表。</span>
      </div>
    </div>

    <!-- 上传区域 -->
    <div class="selfcheck-upload-section">
      <h3 class="upload-title">上传数据表</h3>
      <div class="upload-area">
        <input type="file" accept=".csv,.tsv,.xlsx" @change="$emit('file-upload', $event)" id="selfcheck-file" />
        <label for="selfcheck-file" class="upload-label">
          <span class="upload-btn-text">选择文件</span>
          <span class="upload-filename" v-if="fileName">{{ fileName }}</span>
          <span class="upload-placeholder" v-else>未选择任何文件</span>
        </label>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="selfcheck-actions">
      <button
        class="submit-btn selfcheck-submit"
        @click="$emit('submit')"
        :disabled="!fileName || isSubmitting"
      >
        <span v-if="!isSubmitting">{{ currentTool.btnText || '开始运行' }}</span>
        <span v-else>处理中...</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelfcheckWorkspace',
  props: {
    currentTool: {
      type: Object,
      required: true
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    fileName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.selfcheck-workspace {
  flex: 1;
  overflow-y: auto;
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}
.selfcheck-header {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e8e8e8;
}
.selfcheck-title {
  font-size: 28px;
  color: #1a1a2e;
  margin: 0 0 12px 0;
  font-weight: 600;
}
.selfcheck-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}
.selfcheck-table-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0;
}
.table-formats {
  font-size: 13px;
  color: #999;
}
.table-container {
  overflow-x: auto;
  margin-bottom: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}
.selfcheck-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.selfcheck-table th,
.selfcheck-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e8e8e8;
}
.selfcheck-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
}
.selfcheck-table td {
  color: #666;
}
.selfcheck-table tbody tr:last-child td {
  border-bottom: none;
}
.selfcheck-table tbody tr:hover {
  background: #f8f9fa;
}
.template-downloads {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #1a1a2e;
  transition: all 0.3s ease;
}
.download-btn:hover {
  border-color: #667eea;
  color: #667eea;
  background: rgba(102, 126, 234, 0.05);
}
.download-icon {
  font-size: 16px;
}
.selfcheck-upload-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.upload-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 16px 0;
}
.upload-area {
  border: 2px dashed #e8e8e8;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s ease;
}
.upload-area:hover {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.02);
}
.upload-area input[type="file"] {
  display: none;
}
.upload-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.upload-btn-text {
  padding: 8px 16px;
  background: #f5f7fa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  font-size: 14px;
  color: #1a1a2e;
  transition: all 0.3s ease;
}
.upload-label:hover .upload-btn-text {
  background: #667eea;
  color: white;
  border-color: #667eea;
}
.upload-filename {
  font-size: 14px;
  color: #667eea;
  font-weight: 500;
}
.upload-placeholder {
  font-size: 14px;
  color: #999;
}
.selfcheck-actions {
  padding-top: 8px;
}
.selfcheck-submit {
  background: linear-gradient(135deg, #2d5016 0%, #4a7c23 100%);
  padding: 14px 48px;
}
.selfcheck-submit:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(45, 80, 22, 0.4);
}
@media (max-width: 768px) {
  .selfcheck-workspace {
    padding: 20px 16px;
  }
  .selfcheck-title {
    font-size: 22px;
  }
  .selfcheck-table-section,
  .selfcheck-upload-section {
    padding: 16px;
  }
  .selfcheck-table th,
  .selfcheck-table td {
    padding: 8px 12px;
    font-size: 12px;
  }
  .template-downloads {
    flex-direction: column;
    align-items: flex-start;
  }
  .download-btn {
    width: 100%;
    justify-content: center;
  }
  .upload-label {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
